const ClassNamePassthrough = ({
  children,
  className
}) => children(className);

export { ClassNamePassthrough as C };
//# sourceMappingURL=ClassNamePassthrough-BOut0eKj.js.map
